<template>
  <v-toolbar :color="hasSelectedItems ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" dense>
    <v-tooltip
      :disabled="!disabled"
      bottom
    >
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-checkbox
          @change="handleCheckboxClick"
          :value="selectedAll"
          :indeterminate="indeterminate"
          :disabled="disabled"
          :label="label"
          color="primary"
          hide-details
          dense
        />
      </div>
      </template>
      <span>{{ disabledTooltipText }}</span>
    </v-tooltip>
    <div v-if="hasSelectedItems" class="primary--text">{{ selectedFaturamentoItensCount | pluralize }} de {{ totalFaturamentoItens }}</div>
    <v-spacer />
    <template v-if="!hasSelectedItems">
      <div class="mr-2">
        <conciliacao-faturamento-itens-sort />
      </div>
      <conciliacao-faturamento-itens-filter />
    </template>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import ConciliacaoFaturamentoItensFilter from './ConciliacaoFaturamentoItensFilter.vue'
import ConciliacaoFaturamentoItensSort from './ConciliacaoFaturamentoItensSort.vue'

export default {
  components: {
    ConciliacaoFaturamentoItensFilter,
    ConciliacaoFaturamentoItensSort
  },
  computed: {
    ...mapGetters(
      'conciliacao',
      ['selectedFaturamentoItensCount', 'totalFaturamentoItens', 'selectedPagamentoItensCount', 'hasSelectedItemSistema', 'hasFaturamentoItemConciliado']
    ),
    selectedAll () {
      return this.selectedFaturamentoItensCount > 0 && this.selectedFaturamentoItensCount === this.totalFaturamentoItens
    },
    indeterminate () {
      return this.selectedFaturamentoItensCount > 0 && this.selectedFaturamentoItensCount < this.totalFaturamentoItens
    },
    disabledByNN () {
      return this.totalFaturamentoItens === 0 || this.selectedPagamentoItensCount > 1
    },
    disabledByItemSistema () {
      return this.hasSelectedItemSistema && this.hasFaturamentoItemConciliado
    },
    disabled () {
      return this.disabledByNN || this.disabledByItemSistema
    },
    disabledTooltipText () {
      if (this.disabledByNN) {
        return 'Não é possível selecionar mais de um item.'
      } else if (this.disabledByItemSistema) {
        return 'Não é possível conciliar restante de guia com item já conciliado.'
      } else {
        return ''
      }
    },
    label () {
      return this.selectedFaturamentoItensCount === 0 ? 'Selecionar todos os itens' : undefined
    },
    hasSelectedItems () {
      return this.selectedFaturamentoItensCount > 0
    }
  },
  methods: {
    handleCheckboxClick (checked) {
      if (checked) {
        this.$store.dispatch('conciliacao/selectAllFaturamentoItens')
      } else {
        this.$store.dispatch('conciliacao/deselectAllFaturamentoItens')
      }
    }
  },
  filters: {
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum item selecionado'
      } else if (count === 1) {
        return '1 item selecionado'
      } else {
        return `${count} itens selecionados`
      }
    }
  }
}
</script>
